import { makeStyles } from "@mui/styles";

// Use fixed spacing values to avoid theme.spacing dependency
export default makeStyles(() => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 700,
  },
  input: {
    marginLeft: 8, // theme.spacing(1) = 8px
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  filter: {
    minWidth: 350,
  },
  table: {
    minWidth: 150,
  },
  formControl: {
    margin: 8, // theme.spacing(1) = 8px
    minWidth: 150,
  },
}));
